module.exports = __webpack_public_path__ + "img/metal_ag@2x.a0806800.png";